import { NoMatchPage } from "components/NoMatchPage";
import JobProvider from "context/jobProviders/JobProvider";
import { FC } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { JobDetailsPage } from "./JobDetailsPage";

const Router: FC = () => {
  const { id } = useParams();
  return (
    <Routes>
      <Route element={<JobProvider jobId={id} />}>
        <Route path="/*" element={<JobDetailsPage />} />
      </Route>
      <Route path="*" element={<NoMatchPage />} />
    </Routes>
  );
};
export default Router;
